import { tokenize } from "./tokenizer";
import { parse } from "./parser";
import type { RQLError } from "./types";

// APP-1279/APP-1280: filtering is pushed down to SQL (sent as &q=), so the
// client no longer evaluates RQL over rows. It still parses the query to give
// immediate feedback in the board modal and to avoid sending an invalid `q`.
export type RQLValidation =
  { success: true } | { success: false; error: RQLError };

export function validateRqlQuery(query: string): RQLValidation {
  if (!query.trim()) {
    return { success: true };
  }
  try {
    parse(tokenize(query));
    return { success: true };
  } catch (error) {
    return { success: false, error: error as RQLError };
  }
}
